module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"thumbnail<%= (video_url !== ''? \"\" : \" no-video-url\") %>\"> <% if(!video_url.length && external_url.length) { %> <a class=\"external-link\" target=\"_blank\" href=\"<%= external_url %>\"> <% } %> <% if(formatted_image.length > 0){ %> <div class=\"img-position\"> <div class=\"img-wrapper\"> <img src=\"\" data-src=\"<%= formatted_image %>\" alt=\"\"> </div> <div class=\"text-container\"> <div class=\"text-line1\"><%- name %></div> <div class=\"text-line2\"><%- description %></div> <% if(alt_description !== '') { %><div class=\"text-line3\"><%= alt_description %></div><% } %> <% if(video_url.length) { %><div class=\"watch-video\">watch video &gt;</div><% } %> </div> </div> <% } %> <% if(!video_url.length && external_url.length) { %></a><% } %> </div> <% if(finalist === '1') { %> <div class=\"single-vote\"> <button class=\"btn-submit <% if(isSubmitted) { %>btn-limit<% } %>\" <% if(isSubmitted) { %> disabled=\"disabled\" <% } %>><%- isSubmitted ? 'Limit Reached' : 'Vote' %></button> </div> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="thumbnail', escape((__stack.lineno=1,  (video_url !== ''? "" : " no-video-url") )), '"> ');__stack.lineno=1; if(!video_url.length && external_url.length) { ; buf.push(' <a class="external-link" target="_blank" href="', escape((__stack.lineno=1,  external_url )), '"> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(formatted_image.length > 0){ ; buf.push(' <div class="img-position"> <div class="img-wrapper"> <img src="" data-src="', escape((__stack.lineno=1,  formatted_image )), '" alt=""> </div> <div class="text-container"> <div class="text-line1">', (__stack.lineno=1,  name ), '</div> <div class="text-line2">', (__stack.lineno=1,  description ), '</div> ');__stack.lineno=1; if(alt_description !== '') { ; buf.push('<div class="text-line3">', escape((__stack.lineno=1,  alt_description )), '</div>');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(video_url.length) { ; buf.push('<div class="watch-video">watch video &gt;</div>');__stack.lineno=1; } ; buf.push(' </div> </div> ');__stack.lineno=1; } ; buf.push(' ');__stack.lineno=1; if(!video_url.length && external_url.length) { ; buf.push('</a>');__stack.lineno=1; } ; buf.push(' </div> ');__stack.lineno=1; if(finalist === '1') { ; buf.push(' <div class="single-vote"> <button class="btn-submit ');__stack.lineno=1; if(isSubmitted) { ; buf.push('btn-limit');__stack.lineno=1; } ; buf.push('" ');__stack.lineno=1; if(isSubmitted) { ; buf.push(' disabled="disabled" ');__stack.lineno=1; } ; buf.push('>', (__stack.lineno=1,  isSubmitted ? 'Limit Reached' : 'Vote' ), '</button> </div> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/social_contestant.ejs
// module id = 247
// module chunks = 0